module.exports = __webpack_public_path__ + "static/media/help_Invertir.d73f12e4.png";